import { Component } from '@angular/core';
import { TextInputAutocompleteMenuComponent } from 'angular-text-input-autocomplete';

@Component({
  templateUrl: './custom-menu.component.html',
  styles: ['ul { display: block; padding: 10px } a { color :#2196f3 }'],
})
export class CustomMenuComponent extends TextInputAutocompleteMenuComponent {}
